import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { ThemeService } from '@shared/services/theme/theme.service';
import { ToastModule } from 'primeng/toast';
import { SvgIconRegistry } from '@ngneat/svg-icon';
import { svgIcons } from './app.registory';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  private lastActivityBroadcast = 0;
  timeOut: ReturnType<typeof setTimeout> | undefined;
  constructor(
    private _auth: AuthService,
    private _theme: ThemeService,
    private registry: SvgIconRegistry
  ) {
    _auth.getAppConfig().subscribe({
      next: (config: any) => {
        if (config) {
          _auth.appConfig.set(config);
          this._theme.switchColor(config.brandColor, 'primary');
          this._theme.switchColor(config.brandAiAssistantColor, 'assistant');
          this._theme.applyFontFamily(config.fontFamily);

          const appTitleElement = document.getElementById('app-title');
          if (appTitleElement) {
            appTitleElement.innerHTML = config.brandName.trim();
          }
        }
      },
    });
    this.registry.register(svgIcons);
  }
  ngOnInit(): void {
    this.resetInactivityTimer();
    // Listen for localStorage token removal in other tabs and trigger logout
    window.addEventListener('storage', (event) => {
      if (event.key === 'token' && event.newValue === null) {
        this._auth.syncLogout();
      }
      // Listen for activity in other tabs and reset timer
      if (event.key === 'activity' && event.newValue) {
        this.resetInactivityTimer();
      }
    });
  }

  resetInactivityTimer() {
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => {
      if (this._auth.isAuthenticated()) {
        this._auth.logout();
      }
    }, 30 * 60 * 1000); // 30 minutes
  }

  ngOnDestroy(): void {
    // Clear any timeouts or subscriptions to prevent memory leaks.
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:keypress', ['$event'])
  onActivity() {
    const now = Date.now();
    // Debounce: only broadcast if at least 1 second has passed since last broadcast
    if (now - this.lastActivityBroadcast > 5000) {
      localStorage.setItem('activity', now.toString());
      this.lastActivityBroadcast = now;
    }
    this.resetInactivityTimer();
  }
}
